module.exports = __webpack_public_path__ + "static/media/YM61_1.e821d996.jpg";